import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=ebe88bf2&scoped=true&"
import script from "./Prize.vue?vue&type=script&lang=js&"
export * from "./Prize.vue?vue&type=script&lang=js&"
import style0 from "./Prize.vue?vue&type=style&index=0&id=ebe88bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe88bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebe88bf2')) {
      api.createRecord('ebe88bf2', component.options)
    } else {
      api.reload('ebe88bf2', component.options)
    }
    module.hot.accept("./Prize.vue?vue&type=template&id=ebe88bf2&scoped=true&", function () {
      api.rerender('ebe88bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/Prize.vue"
export default component.exports